export default function (app) {
  return {
    state: {
      answers: {},
    },
    getters: {

    },
    actions: {
      submitAnswers({ state, dispatch, commit, }) {
        commit('setError', {});
        return app.service('submissions').patch(state.licenseKey, {
          answers: state.answers,
          completed: false,
        });
      },
    },
    mutations: {
      setAnswers: (state, answers) => state.answers = answers,
      setAnswer: (state, { questionId, value, }) => state.answers[questionId] = value,
    },
  };
}
